/*
 * VoxPontFaviconManager — applies the VoxPont favicon + social meta on VoxPont
 * pages and restores the shared HealthDesk tags everywhere else.
 *
 * Mounted once inside the Router (so it can read the active location). The SPA's
 * index.html is shared between HealthDesk and the VoxPont hosts, so the favicon
 * is swapped at runtime per route rather than hardcoded in the HTML. Centralizing
 * it here keeps every VoxPont surface — marketing, auth, onboarding, the brand
 * board, and all product forks (/voxpont2 … /voxpont100) — consistently branded
 * without each page wiring up its own effect.
 */

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { applyVoxPontBranding } from "./voxpontBranding";
import { shouldApplyVoxPontBranding } from "./voxpontMarketingRouting";

export default function VoxPontFaviconManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!shouldApplyVoxPontBranding(pathname)) return undefined;
    // applyVoxPontBranding returns a cleanup that restores the prior head tags.
    return applyVoxPontBranding();
  }, [pathname]);

  return null;
}
